import gql from 'graphql-tag';

const PICK_LIST_FRAGMENT_FOR_SERVICE_DOCKET = gql`
	fragment stockLevelItem on PickListItem {
		id
		spoiledProductQuantity
		removedProductQuantity
		planogramItemQuantityPreService
		planogramItemQuantityPostService
		planogramItemQuantityPostInventoryChange
		suggestedExpiryDatesFromWarehouse
		planogramItemExpiryDatesAtPick
		planogramItemExpiryDatesPostConfirmation
		removedProduct {
			id
			name
		}
		selection
		planogramItem {
			id
			quantity
			parlevel
			capacity
			row
			column
			selection
			enabled
			price
			reportedPrice
			priceBookLocked
			priceBookApplied
			priceBook {
				id
				name
			}
			parlevelUnlocked
			productExpiryScheduleLastCheckedAt
			isIngredient
			planogramItemGroupId
			created
			product {
				id
				name
				imageUrl
				HCGCategory
				HFDCategory
				isFreshFood
				measurementUnit
				tags {
					id
					name
				}
			}
			planogramItemStatistics {
				id
				salesLast7Days
				salesLast14Days
				salesLast30Days
				salesLast365Days
				lastProductChangeTime
			}
			expiryDates
		}
	}

	fragment pickList on PickList {
		id
		pickers {
			id
			firstname
			lastname
			username
			destroyed
		}
		pickListItems {
			...stockLevelItem
		}
	}
`;

export default PICK_LIST_FRAGMENT_FOR_SERVICE_DOCKET;
